// We need those for the development environment, they are not really that secritive.
// Production, however, is only in the pipelines and is protected.
export const SECRETS = {
  DYNAMIC_APP_REG_INITIAL_TOKEN: "utAgiIh+RGTiojcgme7JfKCwgJQVGDDCyE125SitHtPikxYAF+",
  DYNAMIC_APP_REG_JWT_SECRET: "p3tXkjc5jvAMmpsiiTVacHQvoUzFIuSC9KCbIGeYbTgVxrcuMd",
} as const
